export default __webpack_public_path__ + "static/media/like.8c1db44e.svg";